/**
 * Hero section
 */
(function($, window) {
	$(document).ready(function() {
		if ($('body').hasClass('not-logged-in')) {
			/** -- Background images -- **/
			$('.sectionFormcta .bg-image').each(function(i, elm) { 
				var imageSrc = $(elm).find('img').attr('src');
				
				if(imageSrc !== undefined || imageSrc !== "undefined") {
					$(elm).parents('.sectionFormcta').css("background-image", "url(" + imageSrc + ")");
					$(elm).parents('.sectionFormcta').addClass('cover-bg');
					
					$(elm).remove(); 
				}
			});
			/** -- background images end -- **/
		}
		
	});
	
})(jQuery, window);